import React, { useState, useEffect } from "react";
import { FaTimes } from "react-icons/fa";
import BtnGuardar from "../../../../../components/buttons/BtnGuardar";
import BtnCancelar from "../../../../../components/buttons/BtnCancelar";
import apiRoutes from "../../../../../api/apiRoutes";
import { appFetchJson } from "../../../../../utils/http";
import SelectDepartamento from "../../../../../components/select/SelectDepartamento";  

export default function CrearCiudad({ onClose = () => {}, onCreated = () => {} }) {
  const [nombre, setNombre] = useState("");
  const [codigo, setCodigo] = useState("");
  const [nombrePais, setNombrePais] = useState("");
  const [departamento, setDepartamento] = useState(null); // { id, nombre }
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");

  const isValid = nombre.trim() !== "" && codigo.trim() !== "";

  useEffect(() => {
    const onKey = (e) => e.key === "Escape" && onClose();
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [onClose]);

  const guardar = async () => {
    if (!isValid || saving) return;
    setSaving(true);
    setError("");
    try {
      const payload = {
        nombre: nombre.trim(),
        codigo: codigo.trim(),
        nombrePais: nombrePais.trim() || undefined,
        departamentoId: departamento?.id ?? null,
      };
      const created = await appFetchJson(apiRoutes.ciudades.create, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });
      onCreated(created);
      onClose();
    } catch (e) {
      console.error("Error creando ciudad:", e);
      setError(e?.message || "Ocurrió un error al guardar la ciudad.");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="modal-backdrop" onClick={onClose}>
      <div className="modal-panel-lg" onClick={e => e.stopPropagation()}>
        <div className="modal-header flex justify-between items-center">
          <h2 className="section-title">Crear Ciudad</h2>
          <button className="modal-close-x" onClick={onClose}><FaTimes /></button>
        </div>
        <div className="modal-body">
          <p className="text-gray-600 mb-4 italic">Introduzca los datos de la nueva ciudad</p>
          {error && <div className="text-red-600 mb-3 font-medium">{error}</div>}
          <div className="space-y-4">
            <div><label className="form-label">Nombre *</label><input type="text" className="input" value={nombre} onChange={e => setNombre(e.target.value)} placeholder="Nombre de la ciudad" /></div>
            <div><label className="form-label">Código *</label><input type="text" className="input" value={codigo} onChange={e => setCodigo(e.target.value)} placeholder="Código de la ciudad" /></div>
            <div><label className="form-label">País</label><input type="text" className="input" value={nombrePais} onChange={e => setNombrePais(e.target.value)} placeholder="País" /></div>
            <div><label className="form-label">Departamento</label><SelectDepartamento value={departamento} onChange={setDepartamento} /></div>
          </div>
        </div>
        <div className="modal-footer">
          <div className="btn-row">
            <BtnGuardar label="Guardar" isValid={isValid} saving={saving} onClick={guardar} />
            <BtnCancelar onClick={onClose} />
          </div>
        </div>
      </div>
    </div>
  );
}